import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
    root: {
        width: '100%',
    },
    content: {
        width: '90%',
        margin: '0 auto',
        paddingTop: '1.5%',
    },
}));
